import { Dispatch } from 'redux';
import { NOTIFICATION_ACTIONS } from './actions';
import { Notification } from '../../types/index';

export const showNotification =
  (
    message: string,
    type: 'info' | 'success' | 'warning',
    icon: string = null
  ) =>
  (dispatch: Dispatch) => {
    const notification: Notification = {
      id: new Date().valueOf().toString(),
      type: type,
      icon: icon,
      message: message,
    };
    dispatch({
      type: NOTIFICATION_ACTIONS.SHOW_NOTIFICATION,
      payload: notification,
    });
  };

export const hideNotification = (id: string) => (dispatch: Dispatch) => {
  dispatch({
    type: NOTIFICATION_ACTIONS.HIDE_NOTIFICATION,
    payload: id,
  });
};
